export default __webpack_public_path__ + "static/media/des-4.d5d64853.jpg";